export default "__VITE_ASSET__CUNy_6Sc__"